<template>
  <div class="line-item">
    <div class="item-title-bar">
      <div class="divider-line divider-line-start"></div>
      <div class="line-item-index">1</div>
      <div class="line-item-name">研判 {{ info.warningNum }}</div>
      <div class="divider-line divider-line-center"></div>
      <div class="line-item-time">
        上报时间: {{ info.reportTime }}
        <i class="el-icon-caret-top"></i>
      </div>
    </div>
    <div class="line-content">
      <ClipBox class="clip-box">
        <el-image
          style="width: 100%; height: 100%;"
          :src="info.eventImg && info.eventImg.indexOf('http') >= 0 ? info.eventImg : baserUrl + info.eventImg"
          :preview-src-list="[info.eventImg && info.eventImg.indexOf('http') >= 0 ? info.eventImg : baserUrl + info.eventImg]"
          fit="cover"></el-image>
      </ClipBox>
      <ClipBox class="clip-box" v-if="info.eventImg1 !== null">
        <el-image
          style="width: 100%; height: 100%;"
          :src="info.eventImg1.indexOf('http') >= 0 ? info.eventImg1 : baserUrl + info.eventImg1"
          :preview-src-list="[info.eventImg1.indexOf('http') >= 0 ? info.eventImg1 : baserUrl + info.eventImg1]"
          fit="cover">
          <div slot="error" class="image-slot">
            后台正在生成红外报警图片中...请稍后再试
          </div>
        </el-image>
      </ClipBox>
      <ClipBox class="clip-box">
        <div id="container" @click="openBigMap"></div>
      </ClipBox>
    </div>
    <el-dialog
      custom-class="transparent-dia"
      append-to-body
      title=""
      :visible.sync="showMap"
      width="1200px"
      :before-close="closeBigMap">
      <div v-if="showMap" id="big-container"></div>
    </el-dialog>
  </div>
</template>
<script>
  import ClipBox from "@/components/ClipBox";
  import { baserUrl } from "@/plugins/BsaeUrl";
  export default {
    name: "LineItem", // 平台上报状态时
    components: { ClipBox },
    props: {
      info: { type: Object, default: () => {} }
    },
    data() {
      return {
        baserUrl: baserUrl,
        map: null,
        bigMap: null,
        showMap: false
      };
    },
    created() {},
    mounted() {
      this.mapInit()
    },
    beforeDestroy() {
      this.map.destroy();
    },
    methods: {
      mapInit() {
        const center = new TMap.LatLng(this.info.lat, this.info.lng)
        //定义map变量，调用 TMap.Map() 构造函数创建地图
        this.map = new TMap.Map(document.getElementById('container'), {
          center: center,//设置地图中心点坐标
          zoom: 14,   //设置地图缩放级别
          baseMap: {  // 设置卫星地图
            type: 'satellite'
          }
        });
        //创建并初始化MultiMarker
        const markerLayer = new TMap.MultiMarker({
          map: this.map,  //指定地图容器
          //点标记数据数组
          geometries: [{
            "id": "1",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
            "styleId": 'myStyle',  //指定样式id
            "position": center,  //点标记坐标位置
            "properties": {//自定义属性
              "title": "marker1"
            }
          }]
        })
        this.map.on("click", () => {
          this.openBigMap()
        })
      },
      openBigMap () {
        this.showMap = true
        const center = new TMap.LatLng(this.info.lat, this.info.lng)
        //定义map变量，调用 TMap.Map() 构造函数创建地图
        this.bigMap = new TMap.Map(document.getElementById('big-container'), {
          center: center,//设置地图中心点坐标
          zoom: 14,   //设置地图缩放级别
          baseMap: {  // 设置卫星地图
            type: 'satellite'
          }
        });
        //创建并初始化MultiMarker
        const markerBigLayer = new TMap.MultiMarker({
          map: this.bigMap,  //指定地图容器
          //点标记数据数组
          geometries: [{
            "id": "1",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
            "styleId": 'myStyle',  //指定样式id
            "position": center,  //点标记坐标位置
            "properties": {//自定义属性
              "title": "marker1"
            }
          }]
        })
      },
      closeBigMap () {
        this.showMap = false
        this.bigMap.destroy()
      }
    }
  }
</script>

<style scoped lang="less">
#container, #big-container{
  /deep/.rotate-circle, /deep/.tmap-zoom-control, /deep/.tmap-scale-control, /deep/ .logo-text, /deep/ img{
    display: none;
  }
}
#container{
  height: 180px;
}
#big-container{
  height: 500px;
}
  .line-item {
    .item-title-bar {
      display: flex;
      align-items: center;
      margin-top: 12px;
      .btn{
        width: 140px;
        height: 50px;
        background-size: 100% 100%;
        text-align: center;
        line-height: 50px;
        font-size: 18px;
      }
      .box2{
        background-image: url("../../../../assets/img/box2.png");
        color: #00FFF6;
      }
      .box4{
        background-image: url("../../../../assets/img/box4.png");
        color: #00B2FF;
      }
      .line-item-index {
        position: relative;
        width: 38px;
        height: 31px;
        margin: 0 10px 0 3px;
        font-weight: bold;
        font-style: italic;
        font-size: 20px;
        color: #00b2ff;
        text-align: center;
        line-height: 31px;
        border-radius: 4px;
        box-shadow: 0 0 12px 4px rgba(0, 178, 255, 0.5) inset;

        &::after {
          position: absolute;
          top: 50%;
          right: 0;
          transform: translate(100%, -50%);
          content: "";
          border: 4px solid transparent;
          border-left-color: rgba(0, 178, 255, 0.4);
        }
      }

      .line-item-name {
        margin-right: 6px;
        font-size: 18px;
        color: #ffffff;
      }

      .line-item-time {
        display: flex;
        align-items: center;
        margin-left: 10px;
        font-size: 14px;
        color: #00b2ff;

        .el-icon-caret-top {
          font-size: 22px;
          margin-left: 5px;
        }
      }
    }

    .divider-line {
      border-bottom: 1px dashed #00fff6;

      &.divider-line-start {
        width: 50px;
      }

      &.divider-line-center {
        width: 0;
        flex: auto;
      }
    }

    .line-content {
      display: flex;

      .clip-box {
        width: 373px;
        height: 182px;
        margin-top: 20px;
        margin-left: 40px;
      }

      .person-info-wrapper {
        .person-info-box {
          width: 100%;
          height: 100%;
          display: flex;

          .person-img {
            width: 190px;
            height: 100%;
            object-fit: cover;
          }

          .person-info {
            width: 0;
            height: 100%;
            flex: auto;
            padding: 8px 10px;
            box-sizing: border-box;

            .info-item {
              line-height: 26px;
              margin-bottom: 4px;
              .info-item-label {
                color: #00b2ff;
                font-size: 14px;
              }

              .info-item-cell {
                display: flex;
                color: #ffffff;
                font-size: 14px;
                .cell-label {
                  width: 52px;
                }
              }
            }
          }
        }
      }
    }
  }
  /deep/.image-slot{
    text-align: center;
    line-height: 182px;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
  }
</style>
